module.exports = __webpack_public_path__ + "img/Home_Mobile_03.c243a07a.jpg";